import { VITE_FORGE_URL } from '../../constants';
import { SceneUserRow } from '../types';
import { Stream } from './Stream';

export class SceneIdsStream extends Stream<SceneUserRow> {
	private _onUpdate: (sceneIds: Set<string>) => void;

	constructor(userId: string, onUpdate: (sceneIds: Set<string>) => void) {
		const url = VITE_FORGE_URL + '/electric/scene-ids';
		const params = { userId };

		const onError = (error: Error) => {
			console.error('Scene IDs stream error:', error);
			this._onUpdate(new Set());
		};

		super(url, params, onError, 'sceneIds');
		this._onUpdate = onUpdate;
	}

	onShapeData(rows: SceneUserRow[]) {
		const sceneIds = new Set(rows.map((sceneUsers) => sceneUsers.scene_id));
		this._onUpdate(sceneIds);
	}

	onStreamMessages(_messages: Array<unknown>) {
		// No optimistic updates needed for sceneIds (they aren't even part of redux state)
	}
}
